/* 24-10 snelheid: foto's van de volgende pagina alvast ophalen.
   Bij hover (desktop) of aanraken (mobiel) van een collectie- of productlink, en zodra een menu
   openklapt, halen we die pagina's op en laden de eerste foto's in dezelfde maat als de kaart
   straks vraagt. Bij de klik staan ze dan in de cache en verschijnt alles meteen.
   Maximaal 16 pagina's per bezoek. */
(function () {
  var gedaan = {}, aantal = 0, timer = null;

  function warm(a, n) {
    if (!a || !a.href || a.origin !== location.origin) return;
    if (!/^\/(collections|products)\//.test(a.pathname)) return;
    var u = a.href.split('#')[0];
    if (u === location.href.split('#')[0] || gedaan[u] || aantal >= 16) return;
    gedaan[u] = 1; aantal++;
    fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var imgs = d.querySelectorAll('.card .shot img');
      if (!imgs.length) imgs = d.querySelectorAll('main img');
      for (var i = 0; i < Math.min(imgs.length, n || 6); i++) {
        var s = imgs[i], im = new Image();
        if (s.getAttribute('sizes')) im.sizes = s.getAttribute('sizes');
        if (s.getAttribute('srcset')) im.srcset = s.getAttribute('srcset');
        if (s.getAttribute('src')) im.src = s.getAttribute('src');
      }
    }).catch(function () {});
  }

  document.addEventListener('touchstart', function (e) {
    warm(e.target.closest && e.target.closest('a[href]'));
  }, { passive: true });
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    clearTimeout(timer);
    if (a) timer = setTimeout(function () { warm(a); }, 65);
  });
  /* Menu open = de klant gaat zo kiezen: de collecties in dat paneel alvast opwarmen. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[aria-controls]');
    var p = b && document.getElementById(b.getAttribute('aria-controls'));
    if (!p) return;
    setTimeout(function () {
      var links = p.querySelectorAll('a[href*="/collections/"]');
      for (var i = 0; i < Math.min(links.length, 6); i++) warm(links[i], 4);
    }, 50);
  });
})();
